import { Component } from 'react';
import { Box } from '@mui/material';

import Paragraph from '../helpers/Paragraph';

export default class Bio extends Component {
    render() {
        return(
            <Box>
                <Paragraph imageSide='right' imageType='square'
                           image='img/avatar/masters.jpg'
                           imageAlt='My dissertation defense'>
                    <p>
                        I'm a Software Engineer with a Master's in Informatics
                        and Computing Engineering from <a className='link'
                        href='https://sigarra.up.pt/feup'>FEUP</a>,
                        where I defended my dissertation on <a className='link'
                        href='https://hdl.handle.net/10216/151971'>
                        "Last-Mile Delivery Problem Representation in
                        Reinforcement Learning"</a> in July 2023.
                    </p>
                    <p>
                        I spent two years at <a className='link'
                        href='https://criticalsoftware.com'>Critical Software
                        </a> developing and testing software
                        for satellites in the space sector. That experience
                        solidified my love for working directly with customers
                        and deepened my appreciation for the critical role that
                        thorough testing and quality assurance play in
                        mission-critical applications.
                    </p>
                </Paragraph>

                <p>
                    Now, I'm pursuing entrepreneurship, driven by my passion
                    for working closely with clients and solving their unique
                    challenges. My expertise spans software testing, embedded
                    systems development, CI/CD, DevOps, and quality assurance.
                    I'm particularly drawn to opportunities in the space
                    sector, though I'm open to projects across various domains
                    where I can make a meaningful impact.
                </p>

                <p>
                    I'm proficient in C, C++, and Rust, and I love tackling
                    complex problems where quality and reliability are key.
                    My approach combines technical rigor with a genuine
                    interest in understanding what customers need and
                    delivering solutions that work.
                </p>

                <Paragraph imageSide='left' imageType='square'
                           image='img/avatar/dogs.jpg' imageAlt='My dogs'>
                    When I'm not coding or exploring new business ideas, you'll
                    find me playing with my dogs, working on puzzles, gaming
                    with my brother, or baking healthy treats (usually for him).
                </Paragraph>

                <p>
                    I'm always excited to connect with potential clients,
                    collaborators, or fellow entrepreneurs. Check out <a
                    className='link' href='/projects'>my projects</a> below,
                    and feel free to reach out via email or LinkedIn.
                    Whether you have a project in mind or just want to chat
                    about space software, testing, or embedded systems,
                    I'd love to hear from you.
                </p>
            </Box>
        );
    }
}
